import { laptopSmallMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import { LogoBox as AgentLogo } from '@propertypal/web-ui/src/agents/AgentLogo.style';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import styled from 'styled-components';

export const CoverPhoto = styled.div`
  background-size: cover;
  height: 280px;
  width: 100%;
`;

export const Header = styled.div`
  background-color: ${({ theme }) => theme.textDark};
  color: ${({ theme }) => theme.white};
`;

export const HeaderRow = styled.div`
  position: relative;
  display: flex;
  max-width: ${MAX_WIDTH}px;
  width: 100%;
  margin: 0 auto;
  padding: 30px 30px 15px 30px;
  justify-content: space-between;

  ${AgentLogo} {
    position: absolute;
    top: -75px;
    left: 30px;
    border: 2px solid white;
  }

  p {
    a {
      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media (${tabletMax}) {
    flex-direction: column;
    text-align: center;

    ${AgentLogo} {
      left: 0;
      right: 0;
      margin: auto;
    }

    & > div:last-child {
      text-align: center;
    }
  }
`;

export const BranchesWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const CallAgentText = styled.p`
  color: ${({ theme }) => theme.backgroundMid};

  @media (${tabletMax}) {
    display: none;
  }
`;

export const Content = styled.div`
  display: flex;
  margin: 30px 0;
  gap: 30px;

  @media (${laptopSmallMax}) {
    flex-direction: column;
  }
`;

export const TextWrapper = styled.div`
  flex: 1;
  margin-bottom: 60px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 15px 0;
  }

  p {
    font-size: 18px;
  }
`;

export const FormWrapper = styled.div`
  background-color: ${({ theme }) => theme.backgroundLighter};
  padding: 20px;
  border-radius: 6px;
  flex: 0 0 450px;
  align-self: flex-start;

  @media (${laptopSmallMax}) {
    flex: 1;
    width: 100%;
  }
`;

export const AccreditationsWrapper = styled.div`
  background-color: ${({ theme }) => theme.backgroundLighter};
  padding: 15px;
  text-align: center;
  border-radius: 6px;
  margin: 30px 0;

  h3 {
    font-size: 21px;
  }
`;
